import Vue from 'vue';
class BaseModel extends Vue {
}
export default BaseModel;

// ./src/model/modules/base.js



// WEBPACK FOOTER //
// ./src/model/modules/base.js